import React, { FC, ReactNode, useEffect, useRef } from 'react';
import { styled } from 'linaria/react';
import { TspAutoComplete } from '@features/tsp/autocomplete';
import { TspSuggestionItem, SearchPayee } from '@entities/tsp';
import { Button } from '@shared/ui/molecules';
import { Modal, ModalProps } from '@shared/ui/organisms';
import { Spinner, Text, TextButton } from '@shared/ui/atoms';
import SearchInputMobile from './SearchInputMobile';
import SuggestButton from './SuggestButton';
type SuggestModalProps = ModalProps;
interface SearchModalMobileProps extends ModalProps {
  servicesForSearch?: SearchPayee[];
  renderSuggestModal: (props: SuggestModalProps) => ReactNode;
}
const SearchModalMobile: FC<SearchModalMobileProps> = ({
  open,
  onClose,
  servicesForSearch,
  renderSuggestModal
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);
  return <Modal mobile open={open} onClose={onClose}>
      <ContentWrapper>
        <TspAutoComplete servicesForSearch={servicesForSearch}>
          {({
          searchTerm,
          onSearchTermChange,
          suggestions,
          isReady
        }) => <>
              <TopSection>
                <SearchInputMobile ref={inputRef} value={searchTerm} onChange={onSearchTermChange} placeholder="Fortnite..." />
                <TextButton color="primary" onClick={onClose}>
                  <Text family="MTSWide" size="captionS" weight="bold" textTransform="uppercase">
                    Закрыть
                  </Text>
                </TextButton>
                {/* <Button variant="transparent" size="32" onClick={onClose}>
                  Закрыть
                 </Button> */}
              </TopSection>
              <BottomSection>
                {searchTerm && <SuggestionsWrapper>
                    {!isReady ? <SpinnerWrapper>
                        <Spinner />
                      </SpinnerWrapper> : <>
                        {suggestions.length > 0 ? suggestions.map(item => <TspSuggestionItem key={item.providerName} item={item} />) : <TextWrapper>
                            <Text family="MTSCompact" size="pS" weight="medium" color="secondary">
                              По вашему запросу ничего не нашли :(
                            </Text>
                          </TextWrapper>}
                        <SuggestButton renderSuggestModal={renderSuggestModal} />
                      </>}
                  </SuggestionsWrapper>}
              </BottomSection>
            </>}
        </TspAutoComplete>
      </ContentWrapper>
    </Modal>;
};
export default SearchModalMobile;
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c3vnitn",
  propsAsIs: false
});
const TopSection = /*#__PURE__*/styled('div')({
  name: "TopSection",
  class: "t1aoqpws",
  propsAsIs: false
});
const BottomSection = /*#__PURE__*/styled('div')({
  name: "BottomSection",
  class: "bt3m5y7",
  propsAsIs: false
});
const SuggestionsWrapper = /*#__PURE__*/styled('div')({
  name: "SuggestionsWrapper",
  class: "str8r7",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t1j7tty7",
  propsAsIs: false
});
const SpinnerWrapper = /*#__PURE__*/styled('div')({
  name: "SpinnerWrapper",
  class: "ssdh2xl",
  propsAsIs: false
});

require("./SearchModalMobile.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SearchModalMobile.tsx");